const UPDATE_SECKILL_INFO = 'UPDATE_SECKILL_INFO'
const UPDATE_SECKILL_DETAILS = 'UPDATE_SECKILL_DETAILS'
const UPDATE_PAY_SUCCESS = 'UPDATE_PAY_SUCCESS'

const types = {
  UPDATE_SECKILL_INFO,
  UPDATE_SECKILL_DETAILS,
  UPDATE_PAY_SUCCESS
}

const state = {
  info: false,
  details: false,
  isPaySuccess: false
}

const getters = {
  info({info}) {
    return info
  },
  details({details}) {
    return details
  },
  isPaySuccess({isPaySuccess}) {
    return isPaySuccess
  },
  //是否开通白条0未开通1已开通
  isOpen({info}) {
    return info && info.isOpen || 0
  },
  //是否具有首单资格0没有1有
  isFirst({info}) {
    return info && info.isFirst || 0
  },
  //是否设置提醒0未设置1设置
  isRemind({info}) {
    return info && info.setRemind == 1 || false
  },
  //是否开始秒杀0未开始1进行中
  startStatus({info}) {
    return info && info.startStatus || 0
  },
  //倒计时
  end({info}) {
    return (info && info.nextTime > 0) ? info.nextTime / 1000 : -999
  },
  //高铁券
  gtCoupons({info}) {
    return info && info.whiteBarProducts || false
  },
  //活力精选商品
  hljxGoods({info}) {
    return info && info.jxProducts || false
  },
  //是否全部售罄
  isAllSellOut(state, {startStatus, gtCoupons, hljxGoods}) {
    let result = false

    //进行中
    if (startStatus == 1 && gtCoupons && hljxGoods) {
      result = true
      let len = gtCoupons.length

      for (; len--;) {
        let item = gtCoupons[len]

        if (item.status < 2) {
          result = false
          break
        }
      }

      if (result) {
        len = hljxGoods.length

        for (; len--;) {
          let item = hljxGoods[len]

          if (item.seckillStatus < 2) {
            result = false
            break
          }
        }
      }
    }

    return result
  }
}

const mutations = {
  [types.UPDATE_SECKILL_INFO](state, info) {
    if (info) {
      state.info = info
    }
    else {
      state.info = false
    }
  },
  [types.UPDATE_SECKILL_DETAILS](state, details) {
    let info = false

    if (details) {
      info = {
        productid: details.productid,
        type: details.type,
        period: details.period,
        name: details.name,
        price: details.price,
        validity: details.validity,
        descrs: details.descrs,
        isSellOut: details && details.status == 2 || false
      }

      info.per = getPer(info.isSellOut, details.sellCount, details.totalCount)
    }

    state.details = info
  },
  [types.UPDATE_PAY_SUCCESS](state, isSuccess) {
    state.isPaySuccess = isSuccess
  }
}

function getPer(isSellOut, sellCount, totalCount) {
  let per = 0

  if (isSellOut) {
    per = 100
  }
  else {
    per = ((sellCount / totalCount) * 100).toFixed(0)
    per = per <= 0 ? 0 : per
    per = per >= 100 ? 100 : per
  }

  return `${per}%`
}

const actions = {
  updateSeckillInfo({commit}, info) {
    commit(types.UPDATE_SECKILL_INFO, info)
  },
  updateSeckillDetails({commit, getters}, productid) {
    let details = false

    if (productid && getters.gtCoupons) {
      let len = getters.gtCoupons.length

      for (; len--;) {
        let item = getters.gtCoupons[len]

        if (productid == item.productid) {
          details = item
          break
        }
      }
    }

    commit(types.UPDATE_SECKILL_DETAILS, details)
  },
  updatePaySuccess({commit}, isSuccess) {
    commit(types.UPDATE_PAY_SUCCESS, isSuccess)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/projects/huoliIOUSecKill/store/seckill.js